import { User } from "./user.service";

export const TOKEN_KEY = "user-parceiro";

export class PermissaoRecursos {

    user = new User()

    // /vouchers
    public static PAGINA_VOUCHERS:string = "3adbde66-fd2d-49d3-82aa-16ea485d686e"
    public static PAGINA_VOUCHERS_DETALHAMENTO:string = "a57b0186-b62d-4943-bf8b-3d25d4866898"

    // /parceiros
    public static PAGINA_PARCEIROS:string = "b01e1110-09ea-4593-b167-27bc63382c9c"
    public static PAGINA_PARCEIROS_DETALHAMENTO:string = "1ad60c33-6593-4050-ae44-a9280358f30b"
    public static PAGINA_PARCEIROS_DETALHAMENTO_PRODUTO:string = "47d375d5-4e0a-4847-a32f-1a1f30aaaba3"

    // /dashboard
    public static PAGINA_DASHBOARD:string = "80c0c0ae-d1a8-4087-ac25-8622e65940e6"


    public static PAGINA_PRIMEIRO_ACESSO:string = "91d10528-6575-45ac-b629-5c464aaca421"


    public static PAGINA_FINANCEIRO:string = "e11e43b2-e20d-4b76-8ce7-72decc021f63"
    public static PAGINA_FINANCEIRO_DETALHAMENTO:string = "51a3fdb3-32c7-434b-a848-ce928331b2d2"



    getRecursos(): Array<any>{
        return this.user.getAuth() ? this.user.getAuth().recursos : null
    }

    temPermissao(recurso){
        return this.getRecursos() ? this.getRecursos().find(e => e === recurso) : false
    }

}
